<app-side-menu>
  <div class="contract-form-container">
    <div class="header">
      <div class="d-flex align-items-center mb-3">
        <app-button 
          text="Voltar"
          color="var(--secondary-color)"
          (buttonClick)="cancel()"
          className="me-3">
          <i class="fas fa-arrow-left me-2"></i>
        </app-button>
        <h2>
          <i class="fas fa-car-side"></i>
          Substituir Veículo - Contrato #{{ contractId ? contractId.toString().padStart(4, '0') : '0000' }}
        </h2>
      </div>
      <p>Selecione o novo veículo e confirme os dados do motorista antes de substituir.</p>
    </div>

    <app-loading [show]="isLoading" message="Carregando dados do contrato..."></app-loading>

    <div *ngIf="!isLoading" class="form-card">
      <form [formGroup]="replacementForm" (ngSubmit)="onSubmit()">
        <div class="form-grid">
          
          <!-- Seção: Produto do Contrato / Upgrade de Plano -->
          <div class="form-section">
            <h3><i class="fas fa-box"></i> Produto do Contrato</h3>

            <div class="form-row" *ngIf="contract">
              <div class="form-group">
                <label class="form-label">Plano / Produto do Contrato *</label>
                <select
                  class="form-select"
                  formControlName="productId"
                  (change)="onProductChange()"
                  [class.is-invalid]="replacementForm.get('productId')?.invalid && replacementForm.get('productId')?.touched">
                  <option [ngValue]="null">Selecione um produto</option>
                  <option *ngFor="let p of products" [ngValue]="p.id">
                    {{ p.code }} - {{ p.name }} ({{ p.billingCycle }} • {{ p.days }} dia(s))
                  </option>
                </select>
                <div class="invalid-feedback" *ngIf="replacementForm.get('productId')?.invalid && replacementForm.get('productId')?.touched">
                  Selecione um produto para o contrato.
                </div>

                <div class="mt-2" *ngIf="product">
                  <small class="text-muted d-block">
                    Produto atual selecionado: <strong>{{ product.code }} - {{ product.name }}</strong>
                  </small>
                  <small class="text-muted d-block">
                    Ciclo: {{ product.billingCycle }} • Duração: {{ product.days }} dia(s) • Valor base: {{ product.basePrice | currency:'BRL':'symbol-narrow':'1.2-2':'pt' }}
                  </small>
                  <small class="text-muted d-block mt-1">
                    Você pode aproveitar a substituição de veículo para fazer um upgrade de plano escolhendo outro produto.
                  </small>
                </div>

                <!-- Resumo financeiro similar ao cadastro de contrato -->
                <div class="mt-3" *ngIf="selectedProduct">
                  <div class="alert alert-info mb-0">
                    <div><strong>Resumo do Plano Selecionado</strong></div>
                    <div>Parcelas (semanas): {{ contractWeeksCount }}</div>
                    <div>Valor por parcela: {{ selectedProduct.basePrice | currency:'BRL':'symbol-narrow':'1.2-2':'pt' }}</div>
                    <div>Valor total (estimado): {{ (selectedProduct.basePrice * contractWeeksCount) | currency:'BRL':'symbol-narrow':'1.2-2':'pt' }}</div>
                    <div>Caução: {{ selectedProduct.depositAmount | currency:'BRL':'symbol-narrow':'1.2-2':'pt' }}</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          
          <!-- Seção: Dados do Veículo / Busca por Placa -->
          <div class="form-section">
            <h3><i class="fas fa-info-circle"></i> Dados do Veículo</h3>

            <div class="form-row">
              <div class="form-group">
                <label for="vehiclePlate" class="form-label">Placa *</label>
                <div class="input-group">
                  <input
                    type="text"
                    id="vehiclePlate"
                    formControlName="vehiclePlate"
                    class="form-control"
                    placeholder="ABC-1234"
                    (keyup.enter)="searchVehicleByPlate()"
                    [class.is-invalid]="replacementForm.get('vehiclePlate')?.invalid && replacementForm.get('vehiclePlate')?.touched">
                  <button
                    type="button"
                    class="btn btn-outline-primary"
                    (click)="searchVehicleByPlate()"
                    [disabled]="isSearchingVehicle">
                    <i class="fas" [ngClass]="isSearchingVehicle ? 'fa-spinner fa-spin' : 'fa-search'"></i>
                  </button>
                </div>
                <div class="invalid-feedback" *ngIf="replacementForm.get('vehiclePlate')?.invalid && replacementForm.get('vehiclePlate')?.touched">
                  Placa é obrigatória.
                </div>
                <small class="form-text text-muted">
                  Informe a placa e clique em buscar para carregar automaticamente os dados do veículo cadastrado.
                </small>
              </div>
              <div class="form-group">
                <label for="vehicleModel" class="form-label">Modelo *</label>
                <input type="text" id="vehicleModel" formControlName="vehicleModel" class="form-control" placeholder="Honda CB 600"
                       [class.is-invalid]="replacementForm.get('vehicleModel')?.invalid && replacementForm.get('vehicleModel')?.touched">
                <div class="invalid-feedback" *ngIf="replacementForm.get('vehicleModel')?.invalid && replacementForm.get('vehicleModel')?.touched">
                  Modelo é obrigatório.
                </div>
              </div>
            </div>

            <div class="form-row">
              <div class="form-group">
                <label for="vehicleYear" class="form-label">Ano *</label>
                <input type="number" id="vehicleYear" formControlName="vehicleYear" class="form-control" placeholder="2020"
                       [class.is-invalid]="replacementForm.get('vehicleYear')?.invalid && replacementForm.get('vehicleYear')?.touched">
                <div class="invalid-feedback" *ngIf="replacementForm.get('vehicleYear')?.invalid && replacementForm.get('vehicleYear')?.touched">
                  Ano é obrigatório.
                </div>
              </div>
              <div class="form-group">
                <label for="vehicleColor" class="form-label">Cor</label>
                <input type="text" id="vehicleColor" formControlName="vehicleColor" class="form-control" placeholder="Vermelho">
              </div>
              <div class="form-group">
                <label for="vehicleBrand" class="form-label">Marca</label>
                <input type="text" id="vehicleBrand" formControlName="vehicleBrand" class="form-control" placeholder="Honda">
              </div>
            </div>

            <div class="form-row">
              <div class="form-group">
                <label for="vehicleRenavam" class="form-label">RENAVAM</label>
                <input type="text" id="vehicleRenavam" formControlName="vehicleRenavam" class="form-control" placeholder="12345678901">
              </div>
              <div class="form-group">
                <label for="vehicleChassis" class="form-label">Chassi</label>
                <input type="text" id="vehicleChassis" formControlName="vehicleChassis" class="form-control" placeholder="9BW1234567890123">
              </div>
              <div class="form-group">
                <label for="vehicleCurrentKm" class="form-label">Quilometragem Atual</label>
                <input type="text" id="vehicleCurrentKm" formControlName="vehicleCurrentKm" class="form-control" appNumberMask [decimals]="0" placeholder="Ex: 15.000">
              </div>
            </div>

            <div class="form-row">
              <div class="form-group full-width">
                <label for="vehicleInspectionNotes" class="form-label">Observações da Inspeção</label>
                <textarea id="vehicleInspectionNotes" formControlName="vehicleInspectionNotes" class="form-control" rows="3"
                          placeholder="Descreva o estado do veículo, avarias, etc."></textarea>
              </div>
            </div>
          </div>

          <!-- Seção: Dados do Motorista -->
          <div class="form-section">
            <h3><i class="fas fa-user"></i> Dados do Motorista</h3>
            
            <div class="form-row">
              <div class="form-group">
                <label for="driverName" class="form-label">Nome Completo *</label>
                <input type="text" id="driverName" formControlName="driverName" class="form-control"
                       placeholder="Nome completo do motorista"
                       [class.is-invalid]="replacementForm.get('driverName')?.invalid && replacementForm.get('driverName')?.touched">
                <div class="invalid-feedback" *ngIf="replacementForm.get('driverName')?.invalid && replacementForm.get('driverName')?.touched">
                  Nome do motorista é obrigatório.
                </div>
              </div>

              <div class="form-group">
                <label for="driverCpfCnpj" class="form-label">CPF/CNPJ *</label>
                <input type="text" id="driverCpfCnpj" formControlName="driverCpfCnpj" class="form-control"
                       placeholder="000.000.000-00"
                       [class.is-invalid]="replacementForm.get('driverCpfCnpj')?.invalid && replacementForm.get('driverCpfCnpj')?.touched">
                <div class="invalid-feedback" *ngIf="replacementForm.get('driverCpfCnpj')?.invalid && replacementForm.get('driverCpfCnpj')?.touched">
                  CPF/CNPJ é obrigatório.
                </div>
              </div>
            </div>

            <div class="form-row">
              <div class="form-group">
                <label for="driverCnhNumber" class="form-label">Número da CNH</label>
                <input type="text" id="driverCnhNumber" formControlName="driverCnhNumber" class="form-control"
                       placeholder="12345678901">
              </div>

              <div class="form-group">
                <label for="driverCnhExpiryDate" class="form-label">Validade da CNH</label>
                <input type="date" id="driverCnhExpiryDate" formControlName="driverCnhExpiryDate" class="form-control">
              </div>
            </div>

            <div class="form-row">
              <div class="form-group">
                <label for="driverEmail" class="form-label">E-mail</label>
                <input type="email" id="driverEmail" formControlName="driverEmail" class="form-control"
                       placeholder="email@exemplo.com">
              </div>

              <div class="form-group">
                <label for="driverPhone" class="form-label">Telefone</label>
                <input type="text" id="driverPhone" formControlName="driverPhone" class="form-control"
                       placeholder="(11) 99999-9999">
              </div>
            </div>

            <div class="form-row">
              <div class="form-group">
                <label for="driverStreet" class="form-label">Rua *</label>
                <input type="text" id="driverStreet" formControlName="driverStreet" class="form-control"
                       placeholder="Nome da rua"
                       [class.is-invalid]="replacementForm.get('driverStreet')?.invalid && replacementForm.get('driverStreet')?.touched">
                <div class="invalid-feedback" *ngIf="replacementForm.get('driverStreet')?.invalid && replacementForm.get('driverStreet')?.touched">
                  Rua é obrigatória.
                </div>
              </div>

              <div class="form-group">
                <label for="driverNumber" class="form-label">Número *</label>
                <input type="text" id="driverNumber" formControlName="driverNumber" class="form-control"
                       placeholder="123"
                       [class.is-invalid]="replacementForm.get('driverNumber')?.invalid && replacementForm.get('driverNumber')?.touched">
                <div class="invalid-feedback" *ngIf="replacementForm.get('driverNumber')?.invalid && replacementForm.get('driverNumber')?.touched">
                  Número é obrigatório.
                </div>
              </div>
            </div>

            <div class="form-row">
              <div class="form-group">
                <label for="driverComplement" class="form-label">Complemento</label>
                <input type="text" id="driverComplement" formControlName="driverComplement" class="form-control"
                       placeholder="Apto 45, Bloco A">
              </div>

              <div class="form-group">
                <label for="driverDistrict" class="form-label">Bairro *</label>
                <input type="text" id="driverDistrict" formControlName="driverDistrict" class="form-control"
                       placeholder="Nome do bairro"
                       [class.is-invalid]="replacementForm.get('driverDistrict')?.invalid && replacementForm.get('driverDistrict')?.touched">
                <div class="invalid-feedback" *ngIf="replacementForm.get('driverDistrict')?.invalid && replacementForm.get('driverDistrict')?.touched">
                  Bairro é obrigatório.
                </div>
              </div>
            </div>

            <div class="form-row">
              <div class="form-group">
                <label for="driverCity" class="form-label">Cidade *</label>
                <input type="text" id="driverCity" formControlName="driverCity" class="form-control"
                       placeholder="Nome da cidade"
                       [class.is-invalid]="replacementForm.get('driverCity')?.invalid && replacementForm.get('driverCity')?.touched">
                <div class="invalid-feedback" *ngIf="replacementForm.get('driverCity')?.invalid && replacementForm.get('driverCity')?.touched">
                  Cidade é obrigatória.
                </div>
              </div>

              <div class="form-group">
                <label for="driverState" class="form-label">Estado *</label>
                <input type="text" id="driverState" formControlName="driverState" class="form-control"
                       placeholder="SP" maxlength="2"
                       [class.is-invalid]="replacementForm.get('driverState')?.invalid && replacementForm.get('driverState')?.touched">
                <div class="invalid-feedback" *ngIf="replacementForm.get('driverState')?.invalid && replacementForm.get('driverState')?.touched">
                  Estado é obrigatório.
                </div>
              </div>
            </div>

            <div class="form-row">
              <div class="form-group">
                <label for="driverZipCode" class="form-label">CEP *</label>
                <input type="text" id="driverZipCode" formControlName="driverZipCode" class="form-control"
                       placeholder="01234-567"
                       [class.is-invalid]="replacementForm.get('driverZipCode')?.invalid && replacementForm.get('driverZipCode')?.touched">
                <div class="invalid-feedback" *ngIf="replacementForm.get('driverZipCode')?.invalid && replacementForm.get('driverZipCode')?.touched">
                  CEP é obrigatório.
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- Botões de Ação -->
        <div class="form-actions">
          <app-button 
            text="Cancelar"
            color="#6c757d"
            (buttonClick)="cancel()"
            [disabled]="isSaving">
            <i class="fas fa-times me-2"></i>
          </app-button>
          <button type="submit" class="btn btn-primary" [disabled]="isSaving || replacementForm.invalid">
            <i class="fas fa-save" *ngIf="!isSaving"></i>
            <i class="fas fa-spinner fa-spin" *ngIf="isSaving"></i>
            {{ isSaving ? 'Substituindo...' : 'Substituir Veículo' }}
          </button>
        </div>
      </form>
    </div>
  </div>
</app-side-menu>

